var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.text
    ? _c("p", { staticClass: "text-label" }, [
        _vm._v(_vm._s(_vm.emptyTextPlaceholder)),
      ])
    : _c(
        "div",
        { staticClass: "text-label" },
        [
          _c("p", { staticClass: "inline mr-1" }, [
            _vm._v(" " + _vm._s(_vm.shortText) + " "),
          ]),
          _vm.shouldTextBeShortened
            ? _c(
                "RouterLink",
                {
                  staticClass:
                    "inline-block text-primary-500 hover:underline focus:underline focus:outline-none",
                  attrs: { to: _vm.routeParams },
                },
                [_vm._v(" show more ")]
              )
            : _vm._e(),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }